<template>
    <div
        class="bento-grid"
    >
        <slot />
    </div>
</template>